import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import type { LoanInsuranceForm } from "../types";
import {
  trackCalculatorInit,
  useTrackCalculatorLoad,
} from "../utils/sitecoreTrack";

export const useLoanInsuranceForm = () => {
  const {
    control,
    watch,
    formState: { errors, submitCount, isValid },
  } = useForm<LoanInsuranceForm>({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      age: "35",
      paymentProtection: "5_000",
      lifeProtection: "1_000_000",
    },
  });
  useTrackCalculatorLoad("laneskydd-betalskydd");
  const [isTracked, setIsTracked] = useState(false);
  const trackCalculatorStarted = () => {
    if (!isTracked) {
      trackCalculatorInit();
      setIsTracked(true);
    }
  };
  const allFields = watch();

  // focus on error functionality
  useEffect(() => {
    if (errors) {
      // errors need to be sorted according to keys in the form data type,
      // by default they are sorted in the order they were registered by RHF
      const order: Record<keyof LoanInsuranceForm, number> = {
        age: 1,
        paymentProtection: 2,
        lifeProtection: 3,
      };
      const firstError = Object.keys(errors).sort(
        (a, b) =>
          order[a as keyof LoanInsuranceForm] -
          order[b as keyof LoanInsuranceForm],
      )[0];

      document.getElementsByName(firstError)[0]?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount]);

  const ageFieldRules = {
    required: "Ange din ålder mellan 18 och 63 år",
    min: {
      value: 18,
      message: "Ange din ålder mellan 18 och 63 år",
    },
    max: {
      value: 63,
      message: "Ange din ålder mellan 18 och 63 år",
    },
  };

  return {
    control,
    allFields,
    ageFieldRules,
    errors,
    isValid,
    trackCalculatorStarted,
  };
};
